import type {
  PDFFoxitRect,
  PDFHighlightCoords,
  PDFRatioCoords,
} from "../helper-types";

export function mapRatioToHighlightCoords(
  ratioCoords: PDFRatioCoords,
  pageDimensions: { width: number; height: number },
): PDFHighlightCoords {
  const r = ratioCoords;
  const { width: pageWidth, height: pageHeight } = pageDimensions;
  return {
    lowerLeft: {
      x: r.left * pageWidth,
      y: pageHeight - r.top * pageHeight,
    },
    upperRight: {
      x: (r.left + r.width) * pageWidth,
      y: pageHeight - (r.top + r.height) * pageHeight,
    },
  };
}

export function mapHighlightToRatioCoords(
  highlightCoords: PDFHighlightCoords,
  pageDimensions: { width: number; height: number },
): PDFRatioCoords {
  const { width: pageWidth, height: pageHeight } = pageDimensions;
  const left = highlightCoords.lowerLeft.x / pageWidth;
  const top = (pageHeight - highlightCoords.lowerLeft.y) / pageHeight;
  return {
    left,
    top,
    width: highlightCoords.upperRight.x / pageWidth - left,
    height: 1 - top - highlightCoords.upperRight.y / pageHeight,
  };
}

export function mapHighlightCoordsToFoxitRect(
  highlighCoords: PDFHighlightCoords,
): PDFFoxitRect {
  const { lowerLeft, upperRight } = highlighCoords;

  return {
    left: lowerLeft.x,
    bottom: lowerLeft.y,
    right: upperRight.x,
    top: upperRight.y,
  };
}

export function mapFoxitRectToHighlightCoords(
  foxitRect: PDFFoxitRect,
): PDFHighlightCoords {
  return {
    lowerLeft: {
      x: foxitRect.left,
      y: foxitRect.bottom,
    },
    upperRight: {
      x: foxitRect.right,
      y: foxitRect.top,
    },
  };
}
